'use client';

import React from 'react';
import RenderBodyCopy from '../RenderBodyCopy';
import { VideoAutoPlayPropTypes } from './VideoAutoPlay.types';
const VideoAutoPlay: React.FC<VideoAutoPlayPropTypes> = ({
  className,
  data
}) => {
  const videoRef = React.useRef<HTMLVideoElement>(null);
  React.useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;
    const observerOptions = {
      root: null,
      // using the viewport as the root
      rootMargin: '0px',
      threshold: 0.5 // trigger when at least 50% of the video is visible
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          videoElement.play();
        } else {
          videoElement.pause();
        }
      });
    }, observerOptions);
    observer.observe(videoElement);
    return () => {
      observer.disconnect(); // Cleanup observer when component unmounts
    };
  }, []);
  return <div className={`my-[1.6rem] ${className}`} data-sentry-component="VideoAutoPlay" data-sentry-source-file="VideoAutoPlay.tsx">
      <div style={{
      position: 'relative',
      width: '100%',
      paddingTop: '56.25%',
      overflow: 'hidden'
    }}>
        <video ref={videoRef} style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%'
      }} src={data?.url} loop muted playsInline>
          Sorry, your browser does not support embedded videos.
        </video>
      </div>

      {data?.bodyCopy && <RenderBodyCopy className='mt-[1.6rem] text-center italic leading-[1.8rem] 2xl:mx-[3rem] [&>p>a]:!text-[1.4rem] [&>p>a]:font-[300] lg:[&>p>a]:!text-[1.6rem] [&>p]:!text-[1.4rem] [&>p]:font-[300] lg:[&>p]:!text-[1.6rem]' bodyCopy={data?.bodyCopy?.json?.content} />}
    </div>;
};
export default VideoAutoPlay;